import { graphql } from "gatsby"

// Shared shape for everything FrameModal needs. Any query that wants to open
// the modal for a brand spreads this fragment and runs the node through
// buildFramePayload so the grid, the sash banner, etc. all stay in sync.
export const frameModalFragment = graphql`
  fragment FrameModalData on MarkdownRemark {
    id
    html
    fields {
      slug
    }
    frontmatter {
      title
      location
      website
      facebookLink
      instagramLink
      image1 {
        childImageSharp {
          gatsbyImageData
          id
        }
      }
      image1Description
      lifestyleImages {
        childImageSharp {
          gatsbyImageData
          id
        }
      }
      logo {
        childImageSharp {
          gatsbyImageData
          id
        }
      }
      promo {
        visible
        heading
        text
        startDate
        endDate
      }
    }
  }
`

export const buildFramePayload = node => {
  if (!node || !node.frontmatter) return null

  const fm = node.frontmatter

  const lifestyleImages = Array.isArray(fm.lifestyleImages)
    ? fm.lifestyleImages
        .map(fileNode => fileNode?.childImageSharp?.gatsbyImageData)
        .filter(Boolean)
    : []

  return {
    id: node.id,
    slug: node.fields?.slug,
    title: fm.title,
    location: fm.location,
    logo: fm.logo?.childImageSharp?.gatsbyImageData,
    image: fm.image1?.childImageSharp?.gatsbyImageData,
    imageDescription: fm.image1Description,
    lifestyleImages,
    website: fm.website,
    facebookLink: fm.facebookLink,
    instagramLink: fm.instagramLink,
    html: node.html,
    promo: fm.promo,
  }
}
